<template>
  <article>
    <b-row>
      <LmTextInput
        class="col-6"
        :placeholder="$t('name')"
        :label="$t('name')"
        help="Este es el nombre del Widget con el que se mostrará en los listados"
        :v="$v.value.name"
        v-model="value.name"
      />
      <LmTextInput
        class="col-6"
        :placeholder="$t('title')"
        :label="$t('title')"
        help="Este es el título del gráfico"
        :v="$v.value.title"
        v-model="value.title"
      />
    </b-row>
    <b-row>
      <LmTreeSelect
        class="col-6"
        label="Origen de datos"
        pathToGetOptions="/datatables/all"
        :v="$v.value.dataOrigin"
        v-model="value.dataOrigin"
        @input="onDataOriginChange"
      />
      <LmSelect
        class="col-6"
        label="Propiedades"
        :options="aggOptions"
        v-model="value.aggTerm"
        :v="$v.value.aggTerm"
        :disabled="!value.dataOrigin"
      />
      <LmNumberInputV2
        class="col-6"
        :placeholder="$t('quantity')"
        :label="$t('result_quantity')"
        help="Limita la cantidad de resultados a mostrar en el gráfico"
        :v="$v.value.size"
        v-model="value.size"
      />
      <LmNumberInputV2
          class="col-6"
          :placeholder="$t('Alto')"
          :label="$t('Alto (PX)')"
          help="Alto del widget"
          :v="$v.value.height"
          v-model="value.height"
        />
      <div v-if="value.dataOrigin">
        <!-- Leyenda -->
        <label for="" class="col-12">Leyenda:</label>
        <div class="border p-3 mx-3 mb-3 rounded">
          <div class="row">
            <LmSelect
              class="col-6"
              label="Orientación"
              :options="orientOptions"
              v-model="value.orient"
              help="Orientación de items de la leyenda"
            />
            <LmSelect
              class="col-6"
              label="Icon"
              :options="iconOptions"
              v-model="value.icon"
              help="Iconos de items de la leyenda"
            />
            <LmSelect
              class="col-6"
              label="Overflow"
              :options="overflowOptions"
              v-model="value.overflow"
              help="En la leyenda cuando el texto sobrepasa el ancho lo trunca con tres puntitos o hace un salto de linea."
            />
            <LmNumberInputV2
          class="col-6"
          :placeholder="$t('Ancho')"
          :label="$t('Ancho (PX)')"
          help="Ancho de la leyenda"
          :v="$v.value.width"
          v-model="value.width"
        />
            <LmNumberInputV2
          class="col-6"
          :placeholder="$t('Margen')"
          :label="$t('Posición arriba (PX)')"
          help="Posición top de la leyenda"
          :v="$v.value.top"
          v-model="value.top"
        />
            <LmNumberInputV2
          class="col-6"
          :placeholder="$t('Separación')"
          :label="$t('Separación entre items (PX)')"
          help="Separación entre items de la leyenda"
          :v="$v.value.itemGap"
          v-model="value.itemGap"
        />
        <div class="col-6 flex">
              <LmCheckbox
            subtitle="Scroll"
            labelSingle=" "
            type="single"
            checkValue="scroll"
            uncheckedValue="plain"
            v-model="value.scroll"
            variant="switch"
            help="Muestra la leyenda arriba o a la izquierda."
            />
            </div>
        </div>
      </div>
      <!-- Gráfico -->
      <label for="" class="col-12">Gráfico:</label>
        <div class="border p-3 mx-3 mb-3 rounded">
          <div class="row">
            <LmSelect
              class="col-6"
              label="Orientación"
              :options="orientOptions"
              v-model="value.gridOrient"
            />
            <LmNumberInputV2
            class="col-6"
            :placeholder="$t('Ancho')"
            :label="$t('Ancho (%)')"
            help="Ancho del gráfico"
            :v="$v.value.gridWidth"
            v-model="value.gridWidth"
          />
            <LmNumberInputV2
            class="col-6"
            :placeholder="$t('Posición')"
            :label="$t('Posición Arriba (PX)')"
            help="Posición top del gráfico"
            :v="$v.value.gridTop"
            v-model="value.gridTop"
          />
            <LmNumberInputV2
            class="col-6"
            :placeholder="$t('Posición')"
            :label="$t('Posición Derecha (%)')"
            help="Posición a la derecha del gráfico"
            :v="$v.value.gridRight"
            v-model="value.gridRight"
          />
        </div>
        </div>
      </div>
      <LmCheckbox
        class="col-12"
        :title="$t('available_sizes')"
        type="multiple"
        :options="sizesOptions"
        v-model="value.sizes"
      />
      <LmCheckbox
        class="col-12"
        :title="$t('available_in')"
        type="multiple"
        :options="availableInOptions"
        v-model="value.availableIn"
      />
    </b-row>
  </article>
</template>

<script>
// Utils
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInputV2 from '@/components/form/elements/LmNumberInputV2'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmSelect from '@/components/form/elements/LmSelect'

export default {
  mixins: [lmToasts],
  components: {
    LmTextInput,
    LmCheckbox,
    LmTreeSelect,
    LmSelect,
    LmNumberInputV2
  },
  props: {
    value: Object,
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      availableInOptions: [
        {
          text: 'Bandeja de Entradas',
          value: 'inbox'
        },
        {
          text: 'Dashboard',
          value: 'dashboard'
        },
        {
          text: 'Reportes',
          value: 'report'
        }
      ],
      aggTermKey: 0,
      aggOptions: {
        disabledOption: 'Seleccione una opción',
        content: []
      },
      orientOptions: {
        disabledOption: 'Seleccione una opción',
        content: [{
          text: 'Horizontal',
          value: 'horizontal'
        },
        {
          text: 'Vertical',
          value: 'vertical'
        }]
      },
      overflowOptions: {
        disabledOption: 'Seleccione una opción',
        content: [{
          text: 'Salto',
          value: 'break'
        },
        {
          text: 'Truncado',
          value: 'truncate'
        }]
      },
      iconOptions: {
        disabledOption: 'Seleccione una opción',
        content: [{
          text: 'Circle',
          value: 'circle'
        },
        {
          text: 'Rect',
          value: 'rect'
        },
        {
          text: 'Round Rect',
          value: 'roundRect'
        },
        {
          text: 'Triangle',
          value: 'triangle'
        },
        {
          text: 'Diamond',
          value: 'diamond'
        },
        {
          text: 'Pin',
          value: 'pin'
        },
        {
          text: 'Arrow',
          value: 'arrow'
        },
        {
          text: 'None',
          value: 'none'
        }
        ]
      },
      source: null,
      sizesOptions: [
        {
          text: '25%',
          value: 3
        },
        {
          text: '50%',
          value: 6
        },
        {
          text: '75%',
          value: 9
        },
        {
          text: '100%',
          value: 12
        }
      ]
    }
  },
  validations: {
    value: {
      name: {
        required
      },
      title: {
        required
      },
      dataOrigin: {
        required
      },
      aggTerm: {
        required
      },
      size: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(5)
      }
    }
  },
  methods: {
    async loadAggToRenderOptions (event) {
      const res = await commonsApi.axiosGetWrapper(`/datatables/${event}`)
      this.source = res.data.widget

      if (this.source.fields.length) {
        this.aggOptions.content = this.source.fields.map(el => {
          return {
            text: el.label,
            value: el.value
          }
        })
      }
    },
    async onDataOriginChange (event) {
      try {
        if (!event) {
          this.aggOptions = []
          this.value.aggTerm = null
          return
        }
        this.value.aggTerm = null
        await this.loadAggToRenderOptions(event.id)
        this.value.aggTerm = this.aggOptions?.content[0]?.value
        // Fix temporal.
        // Cuando se cargaban las opciones del select marca
        // la primera por defecto pero el value es null
        this.aggTermKey++
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created () {
    if (this.value.dataOrigin) {
      await this.loadAggToRenderOptions(this.value.dataOrigin.id)
    }
    if (this.isOnEditMode) {
      if (this.value.dataOrigin) {
        await this.loadAggToRenderOptions(this.value.dataOrigin.id)
      }
    }
  }
}
</script>
